'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default ['$scope', '$uibModalInstance', 'pstatus', 'PStatusService', 'StatusService',
    function($scope, $modalInstance, pstatus, PStatusService, StatusService) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        /**
         * Инициализация
         */
        function init() {
            $scope.uniqueName = true;
            $scope.pstatus = angular.copy(pstatus);

            if (!(pstatus === null
                    || angular.equals({}, pstatus)
                    || pstatus.id === null)) {
                $scope.title = `Редактирование статуса сопровождения проекта "${$scope.pstatus.name}"`;
            } else {
                $scope.title = 'Создание нового статуса сопровождения проекта';
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.pstatus.status) {
                    $scope.pstatus.status = data._embedded;
                }
            });
        }

        /**
         * Действие нажатия кнопки "Ok"
         */
        function ok() {
            $modalInstance.close($scope.pstatus);
        }

        /**
         * Действие нажатия кнопки "Cancel"
         */
        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Действие проверки уникальности имени
         * @param {string} name имя
         */
        function checkUniqueName(name) {
            if (name !== null && name.trim() !== '') {
                PStatusService.api.isUniqueName({name: name}, {id: $scope.pstatus.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion
    }];
